import Layout from '@/views/Layout.vue'
import Dashboard from '@/views/Dashboard.vue'

export default {
    path: '/utility',
    component: Layout,
    children: [
        {
            path: '',
            name: 'utility.list',
            component: Dashboard
        },
        {
            path: 'register',
            name: 'utility.register',
            component: () => import('@/views/Registration.vue')
        },
        {
            path: 'payment/*',
            name: 'utility.payment',
            component: () => import('@/views/Payment.vue')
        },
        {
            path: '*',
            name: 'utility.project',
            component: () => import('@/views/Project.vue')
        }
    ]
}
